import React from "react"

export const Field = ({ field, img, info }) => {
  return (
    <div className="field">
      <div className="flex grey m3 round">
        <img className="iconImg m3 flex"
          src={"https://raw.githubusercontent.com/jasonleonhard/img/master/icons/" + img}
          alt={field} />
        <div className="column left m3 flex1 near">
          <div className="label">{field}</div>
          <div className="data">{info}</div>
        </div>
      </div>
    </div>
  )
}
